const END_POINT = {
  TEST_API: 'api/0.4/',
  SEND_MAIL_RESET_PASSWORD: 'admin/auth/reset-password',
  CHANGE_PASSWORD: 'admin/auth/change-password',
  SIGN_UP: 'admin/auth/register',
  GOOGLE_SSO: 'user/auth/google',
  LOGIN: 'admin/auth/login',
  ROLES: 'admin/auth/roles',
  MEMBER_ROLES: 'admin/portfolio-member/all-roles-of-portfolio',
  LOGIN_SSO_GOOGLE: 'admin/auth/login/google',
  LOGIN_SSO_MSAL: 'admin/auth/login/ms',
  RESEND_SIGN_UP_EMAIL: 'admin/auth/send-verify',
  REGISTER_ENTERPRISE: 'admin/auth/register/enterprise',
  REGISTER_PAYMENT_METHOD: 'admin/payment/register',
  VERIFY_SIGN_UP_TOKEN: 'admin/auth/verify-email',
  WEEKLY_NOTE: 'admin/weekly-management/note',
  WEEKLY_MANAGEMENT_ID: 'admin/weekly-management/portfolio',
  GET_WEEKLY_NOTE: 'admin/weekly-management/get-all-by-portfolio-id',
  GET_ALL_CUSTOMER: '/admin/customer',
  REGISTER_INVITATION_EXTERNAL: '/admin/auth/register-by-invitation',
  VERIFY_INVITE_CODE_REGISTER: '/admin/account-management/invite-admin/verify',
  NOTE_UPLOAD_IMAGE: '/admin/drive/uploadImage',
  PORTFOLIO: {
    PORTFOLIO: 'admin/portfolio',
    PORTFOLIO_INFO_USER: 'admin/portfolio/info-user',
    PORTFOLIO_MEMBER: 'admin/portfolio-member',
    PORTFOLIO_MEMBER_INVITE: 'admin/portfolio',
    ALL_MEMBER_PORTFOLIO: 'admin/portfolio',
    GET_PORTFOLIO_BY_USERID: 'admin/portfolio',
    VERIFY_INVITE_MEMBER: 'admin/portfolio/invite-verify',
    ACCEPT_INVITE_MEMBER: 'admin/portfolio/invite-accept',
    DELETE_PORTFOLIO_MEMBER: 'admin/portfolio',
    UPDATE_CURRENCY: 'admin/portfolio'
  },
  LOGOUT: 'admin/auth/logout',
  CHANGE_PLAN: {
    GET_PLAN: '/admin/account-management/plan',
    TO_TEAM_PLAN: '/admin/account-management/upgrate-team-plan',
    TO_ENTERPRISE: '/admin/account-management/upgrate-enterprise-plan',
    TO_BASIC: '/admin/account-management/downgrate-basic-plan'
  },
  SETTING_2FA: {
    RESET_2FA: '/admin/auth/2fa/reset',
    VERIFY_CODE: '/admin/auth/2fa/verify',
    VERIFY_CODE_RESET: '/admin/auth/2fa/reset',
    GENERATE: '/admin/auth/2fa/generate'
  },
  ACCOUNT_INFO: {
    GET_INFO: '/admin/account-management/info',
    UPDATE_BASIC: '/admin/account-management/update-info',
    UPDATE_BUSINESS: '/admin/account-management/update-info-business',
    GET: '/admin/account-management/admin',
    INVITE_EMAIL: '/admin/account-management/invite-admin',
    ACCEPT_INVITE_MEMBER: '/admin/account-management/invite-admin/accept',
    CHANGE_EMAIL: '/admin/account-management/change-email',
    VERIFY_CHANGE_EMAIL: '/admin/account-management/change-email',
    DELETE_ACCOUNT: '/admin/account-management/admin'
  },
  USER_LIST: {
    GET: '/admin/account-management/user',
    BLOCK_OR_ACTIVE: '/admin/account-management/active-member',
    GET_INFO: '/admin/portfolio/info'
  },
  DASHBOARD_MAIN: {
    GET_ALL: '/admin/dashboard/all',
    GET_TAB_BY_DATE: '/admin/dashboard/date',
    GET_PROPORTION_SALES: '/admin/dashboard/proportion-sales',
    GET_SUMMARY: '/admin/dashboard/summary',
    GET_USER_ACTIVITY: '/admin/dashboard/chart/user-activity',
    GET_SALES_TREND: '/admin/dashboard/chart/sales-trend',
    GET_VISIT: '/admin/dashboard/chart/visits',
    GET_TOP_SEARCH: '/admin/dashboard/top-search'
  },
  CONTACT: {
    GET: '/admin/contact'
  },
  PAYMENT: {
    GET: '/admin/payments'
  },
  WEEKLY_AND_HEADCOUNT: {
    FOLDER: '/admin/upload/folders',
    FILE: '/admin/upload/files'
  }
}

export default END_POINT
